"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteServiceChangeEventMutation = exports.useFetchServiceAuditLogQuery = exports.useFetchServiceHistoryQuery = exports.useUpdateServiceMutation = exports.useDeleteServiceMutation = exports.useLazyFetchServiceQuery = exports.useFetchServiceQuery = exports.useSearchServicesQuery = exports.useFetchClientServicesQuery = exports.useCreateServiceMutation = exports.serviceApi = void 0;
// api/serviceApi.ts
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.serviceApi = (0, react_1.createApi)({
    reducerPath: "serviceApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["services"],
    endpoints: function (builder) { return ({
        createService: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/service/create",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["services"],
        }),
        fetchClientServices: builder.query({
            query: function (obj) { return ({
                url: "/v1/service/all",
                method: "GET",
                params: {
                    clientId: obj.clientId,
                    buildingId: obj.buildingId,
                    serviceType: obj.serviceType,
                    page: obj.page,
                    limit: obj.limit,
                },
            }); },
            providesTags: ["services"],
        }),
        searchServices: builder.query({
            query: function (obj) {
                var params = {
                    clientId: obj.clientId,
                    page: obj.page || 1,
                    limit: obj.limit || 10,
                };
                if (obj.search)
                    params.search = obj.search;
                if (obj.buildingId)
                    params.buildingId = obj.buildingId;
                if (obj.serviceType)
                    params.serviceType = obj.serviceType;
                if (obj.isActive !== undefined)
                    params.isActive = obj.isActive;
                return {
                    url: "/v1/service/all",
                    method: "GET",
                    params: params,
                };
            },
            providesTags: ["services"],
        }),
        fetchService: builder.query({
            query: function (serviceId) { return ({
                url: "/v1/service/fetch",
                method: "GET",
                params: {
                    _id: serviceId,
                },
            }); },
            providesTags: ["services"],
        }),
        updateService: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/service/update",
                method: "PUT",
                body: obj,
            }); },
            invalidatesTags: ["services"],
        }),
        deleteService: builder.mutation({
            query: function (_a) {
                var serviceId = _a.serviceId, performedBy = _a.performedBy, reason = _a.reason;
                return ({
                    url: "/v1/service/remove",
                    method: "DELETE",
                    params: __assign({ _id: serviceId, performedBy: performedBy }, (reason ? { reason: reason } : {})),
                });
            },
            invalidatesTags: ["services"],
        }),
        fetchServiceHistory: builder.query({
            query: function (serviceId) { return ({
                url: "/v1/service/history",
                method: "GET",
                params: { _id: serviceId },
            }); },
            providesTags: function (_result, _err, serviceId) { return [{ type: "services", id: "history:".concat(serviceId) }]; },
        }),
        fetchServiceAuditLog: builder.query({
            query: function (_a) {
                var serviceId = _a.serviceId, action = _a.action, includeDeleted = _a.includeDeleted;
                return ({
                    url: "/v1/service/audit-log",
                    method: "GET",
                    params: __assign(__assign({ _id: serviceId }, (action ? { action: action } : {})), (includeDeleted ? { includeDeleted: true } : {})),
                });
            },
            providesTags: function (_result, _err, arg) { return [{ type: "services", id: "audit:".concat(arg.serviceId) }]; },
        }),
        deleteServiceChangeEvent: builder.mutation({
            query: function (_a) {
                var eventId = _a.eventId, performedBy = _a.performedBy, reason = _a.reason;
                return ({
                    url: "/v1/service/audit-log/event",
                    method: "DELETE",
                    body: { eventId: eventId, performedBy: performedBy, reason: reason },
                });
            },
            invalidatesTags: function (_result, _err, arg) { return [
                { type: "services", id: "audit:".concat(arg.serviceId) },
                { type: "services", id: "history:".concat(arg.serviceId) },
            ]; },
        }),
    }); },
});
exports.useCreateServiceMutation = exports.serviceApi.useCreateServiceMutation, exports.useFetchClientServicesQuery = exports.serviceApi.useFetchClientServicesQuery, exports.useSearchServicesQuery = exports.serviceApi.useSearchServicesQuery, exports.useFetchServiceQuery = exports.serviceApi.useFetchServiceQuery, exports.useLazyFetchServiceQuery = exports.serviceApi.useLazyFetchServiceQuery, exports.useDeleteServiceMutation = exports.serviceApi.useDeleteServiceMutation, exports.useUpdateServiceMutation = exports.serviceApi.useUpdateServiceMutation, exports.useFetchServiceHistoryQuery = exports.serviceApi.useFetchServiceHistoryQuery, exports.useFetchServiceAuditLogQuery = exports.serviceApi.useFetchServiceAuditLogQuery, exports.useDeleteServiceChangeEventMutation = exports.serviceApi.useDeleteServiceChangeEventMutation;
